var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 54,
    viewBox: "0 0 107 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7993 33.9404C66.6378 31.6465 60.2853 29.9701 53.0945 29.9701C45.9038 29.9701 39.5512 31.6906 34.3897 33.9404C29.6253 36.058 26.6255 40.8224 26.6255 46.028V53.1305H79.5636V46.028C79.5636 40.8224 76.5637 36.058 71.7993 33.9404ZM35.7573 44.3075C36.1543 43.2928 36.9484 42.4547 37.9189 42.0135C42.7716 39.8519 47.8889 38.7931 53.0504 38.7931C58.256 38.7931 63.3292 39.896 68.1819 42.0135C69.1965 42.4547 69.9465 43.2928 70.3435 44.3075H35.7573Z",
    fill: "url(#paint0_linear_1_64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53853 38.043C2.27402 39.4547 0.156494 42.631 0.156494 46.2043V53.1304H20.0083V46.0279C20.0083 42.3663 21.0229 38.9254 22.7875 35.9255C21.1553 35.6608 19.523 35.4844 17.8025 35.4844C13.4351 35.4844 9.28831 36.4108 5.53853 38.043Z",
    fill: "url(#paint1_linear_1_64)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.65 38.043C96.9007 36.4108 92.7539 35.4844 88.3865 35.4844C86.666 35.4844 85.0337 35.6608 83.4015 35.9255C85.1661 38.9254 86.1807 42.3663 86.1807 46.0279V53.1304H106.033V46.2043C106.033 42.631 103.915 39.4547 100.65 38.043Z",
    fill: "url(#paint2_linear_1_64)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0945 26.6614C60.4176 26.6614 66.329 20.75 66.329 13.4269C66.329 6.1038 60.4176 0.192383 53.0945 0.192383C45.7714 0.192383 39.86 6.1038 39.86 13.4269C39.86 20.75 45.7714 26.6614 53.0945 26.6614ZM53.0945 9.01539C55.5208 9.01539 57.506 11.0006 57.506 13.4269C57.506 15.8532 55.5208 17.8384 53.0945 17.8384C50.6682 17.8384 48.683 15.8532 48.683 13.4269C48.683 11.0006 50.6682 9.01539 53.0945 9.01539Z",
    fill: "url(#paint3_linear_1_64)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8019 11.2072L6.75928 22.2498L17.8019 33.2925L28.8445 22.2498L17.8019 11.2072Z",
    fill: "url(#paint4_linear_1_64)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3867 13.427L77.3579 31.073H99.4154L88.3867 13.427Z",
    fill: "url(#paint5_linear_1_64)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_64",
    x1: 53.0945,
    y1: 29.9701,
    x2: 53.0945,
    y2: 53.1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_64",
    x1: 11.472,
    y1: 35.4844,
    x2: 11.472,
    y2: 53.1304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_64",
    x1: 94.717,
    y1: 35.4844,
    x2: 94.717,
    y2: 53.1304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_64",
    x1: 53.0945,
    y1: 0.192383,
    x2: 53.0945,
    y2: 26.6614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_64",
    x1: 17.8019,
    y1: 11.2072,
    x2: 17.8019,
    y2: 33.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_64",
    x1: 88.3867,
    y1: 13.427,
    x2: 88.3867,
    y2: 31.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups3);
export default __webpack_public_path__ + "static/media/groups_3.ce9fb22d369f772d41a3ca443fc9a68d.svg";
export { ForwardRef as ReactComponent };